import React from "react";

const BS5_Tooltip = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Tooltip Component</h2>
      <p>This is the BS5_Tooltip component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Tooltip;
